<template>
  <div
    v-if="installmentDetails.installments.length > 0"
    class="installment-list"
  >
    <h1 class="listing-titles">
      {{ title }}
    </h1>
    <ul>
      <li
        v-for="installment in installmentDetails.installments"
        :key="installment.amount"
      >
        <InstallmentItem
          :installment="installment"
          :currency-symbol="installmentDetails.currencySymbol"
          @select-installment-item="handleSelectInstallment"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref, watchEffect} from "vue";
import InstallmentItem from "@/components/InstallmentItem.vue";
import {useI18n} from "vue-i18n";
import {IInstallment} from "@/types/IInstallment";
import {useStore} from "vuex";

export default defineComponent({
  name: "InstallmentsList",
  components: {
    InstallmentItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    installmentDetails: {
      type: Object as PropType<IInstallment>,
      required: true,
      default: () => ({
        currencySymbol: "",
        country: "",
        currency: "",
        installments: [],
      }),
    },
  },
  emits: ["select-installment-item"],
  setup(props) {
    const {t} = useI18n();
    const store = useStore();
    const currencySymbol = computed(
      () => props.installmentDetails.currencySymbol
    );

    const sortedInstallments = ref([...props.installmentDetails.installments]);

    watchEffect(() => {
      if (currencySymbol.value) {
        store.dispatch("payOptions/setCurrencySymbol", currencySymbol.value);
      }
      // Sort the local copy of installments based on the amount field
      sortedInstallments.value = [...props.installmentDetails.installments].sort((a, b) => a.amount - b.amount);
    });

    return {
      t,
      sortedInstallments,
    };
  },
  methods: {
    handleSelectInstallment(selectedInstallmentItem) {
      this.$emit("select-installment-item", selectedInstallmentItem);
    },
  },
});
</script>

<style scoped>
.installment-list {
  padding: 16px 22px 150px 22px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.installment-list ul {
  list-style: none;
  padding: 0;
}

.animation-container {
  justify-content: center;
  align-items: center;
  flex: 1;
  display: flex;
}

.animation-container h4 {
  color: var(--Typography-Text-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  margin: auto;
}

.loading-animation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
}
</style>
